import React from 'react';
import PT from 'prop-types';
import { Icon, Modal } from 'semantic-ui-react';
import NoSSR from 'react-no-ssr';
import dictionary from '../../../../lib/dict.json';
import classes from './StatsKey.css';

const StatsKey = ({ lang, abbreviations, duplicatesKeys }) => {
  return (
    <div className={classes.legend}>
      <NoSSR>
        <Modal className={classes.statsModal}
          trigger={(
            <span>
              <Icon
                className={classes.legendIcon}
                name="question circle"
                size="large"
                fitted
              />Stats Key
            </span>
          )}
          closeIcon="close"
          size="small"
        >
          <Modal.Header>Abbreviation Key</Modal.Header>
          <Modal.Content>
            <ul className={classes.list}>
              { abbreviations && abbreviations.map((abbv, idx) => {
                if (typeof abbv !== 'string') {
                  const { displayAbbr, fixedAbbr, groupName } = abbv;
                  return (
                    <li className={classes.listItem} key={idx}>
                      { duplicatesKeys.includes(displayAbbr)
                        ? `${displayAbbr} (${groupName}): ${dictionary[lang][fixedAbbr] && dictionary[lang][fixedAbbr].description}`
                        : `${displayAbbr}: ${dictionary[lang][fixedAbbr] && dictionary[lang][fixedAbbr].description}`
                      }
                    </li>
                  )
                }
                return (
                  <li className={classes.listItem} key={idx}>
                  { dictionary[lang][abbv] ? dictionary[lang][abbv].name : abbv } : { dictionary[lang][abbv] && dictionary[lang][abbv].description }
                  </li>
                )
              })}
            </ul>
          </Modal.Content>
        </Modal>
      </NoSSR>
    </div>
  );
};

StatsKey.propTypes = {
  abbreviations: PT.arrayOf(PT.shape({
    fixedAbbr: PT.string,
    displayAbbr: PT.string,
    groupName: PT.string,
  })).isRequired,
  lang: PT.string,
  duplicatesKeys: PT.arrayOf(PT.string)
};

StatsKey.defaultProps = {
  lang: 'en',
};

export default StatsKey;



// WEBPACK FOOTER //
// ./src/app/components/TableControls/StatsKey/StatsKey.js